<div mat-dialog-content>
    Voulez-vous exporter toutes les données ?
</div>
<div mat-dialog-actions style="justify-content: end;">
    <button mat-button mat-dialog-close>Non</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Oui</button>
</div>
